document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const rows = document.querySelectorAll(
    ".discover-image-grid__scroll-content"
  );

  rows.forEach((row) => {
    const originalContent = Array.from(row.children);

    // Duplicate TWICE for smoother cross-browser performance
    originalContent.forEach((item) => {
      row.appendChild(item.cloneNode(true));
    });
    originalContent.forEach((item) => {
      row.appendChild(item.cloneNode(true));
    });

    // Determine animation direction and speed
    const isReverse = row.closest(".discover-image-grid__row.--middle");
    const isBottom = row.closest(".discover-image-grid__row.--bottom");
    const duration = isBottom ? 93 : 90;

    let started = false;

    function startAnimation() {
      if (started) {
        return;
      }
      started = true;

      const totalWidth = row.scrollWidth;
      const originalContentWidth = totalWidth / 3;
      const endX = isReverse ? 0 : -originalContentWidth;
      const startX = isReverse ? -originalContentWidth : 0;

      gsap.fromTo(
        row,
        { x: startX },
        {
          x: endX,
          duration,
          ease: "none",
          repeat: -1,
          immediateRender: true,
          force3D: true,
        }
      );
    }

    // The marquee must NOT wait for every image to be ready before starting:
    // the section's images are loading="lazy", so most of the (x3 duplicated)
    // row isn't fetched until it scrolls toward the viewport, and waiting for
    // all of them could deadlock the animation forever. Instead, start once the
    // row scrolls into view; images still loading pop in as they fetch (the
    // row is tripled, so there is always content on screen).
    const images = row.querySelectorAll("img");
    const totalImages = images.length;
    let imagesReady = 0;

    function onImageReady() {
      imagesReady++;
      if (imagesReady === totalImages) {
        startAnimation();
      }
    }

    images.forEach((img) => {
      if (img.complete) {
        imagesReady++;
      } else {
        img.addEventListener("load", onImageReady);
        img.addEventListener("error", onImageReady);
      }
    });

    if (totalImages === 0 || imagesReady === totalImages) {
      startAnimation();
    }

    // Viewport trigger: the main path for lazy-loaded images. Start as the row
    // approaches the viewport; the browser will fetch the lazy images that are
    // (or soon become) visible.
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
              startAnimation();
            }
          });
        },
        { rootMargin: "200px 0px" }
      );
      observer.observe(row);
    }

    // Absolute backstop so a slow or unsupported environment can never leave
    // the marquee frozen.
    window.setTimeout(startAnimation, 8000);
  });
});
